import { Receipt } from '@phosphor-icons/react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { useOrders } from '../hooks/use-orders';
import { ORDERS_PATH } from '../utils/slugs';

/**
 * Acesso a "Meus pedidos", com a contagem do que está em andamento.
 *
 * Navega em vez de abrir painel, ao contrário da sacola: a sacola é uma
 * conferência rápida do que se está montando agora, e o pedido é uma consulta
 * — quem vem ver onde está a entrega não está no meio de outra tarefa.
 *
 * O distintivo conta só `open`. Somar os entregues faria o número crescer para
 * sempre e parar de significar qualquer coisa; o que ele responde é "tem algo
 * meu em andamento?".
 */
export function OrdersButton() {
  const { data } = useOrders();
  const emAndamento = data?.open.length ?? 0;

  return (
    <Button
      asChild
      variant="ghost"
      size="icon-sm"
      className="relative"
      aria-label={
        emAndamento === 0
          ? 'Meus pedidos'
          : `Meus pedidos, ${emAndamento} em andamento`
      }
    >
      <Link to={ORDERS_PATH}>
        <Receipt size={18} aria-hidden />
        {emAndamento > 0 && (
          <span
            aria-hidden
            className="absolute -right-1 -top-1 flex h-5 min-w-5 items-center justify-center rounded-full bg-primary px-1 text-[11px] font-semibold leading-none tabular-nums text-primary-foreground"
          >
            {emAndamento > 9 ? '9+' : emAndamento}
          </span>
        )}
      </Link>
    </Button>
  );
}
